export class Usuario {
    id?: number;
    login: string;
    senha?: string;
    nome?: string;
    email?: string;
    token: string;
    perfil: string;
    permissoes: string[]

    constructor() {
        this.login = ''
        this.token = ''
        this.perfil = ''
        this.permissoes = []
    }
}